const ALIGN = 'center'

export default [
  {
    title: '计划组名称',
    key: 'campaignName',
    overflow: true,
    width: 180
  },
  {
    title: '计划系列',
    key: 'adGroupName',
    type: 'basic',
    overflow: true,
    width: 180
  },
  {
    title: '媒体',
    key: 'mediaName',
    type: 'basic',
    width: 70
  },
  {
    title: '账号',
    key: 'adAccountName',
    type: 'basic',
    overflow: true,
    width: 140
  },
  {
    title: '费用',
    key: 'amount',
    sortable: 'custom',
    type: 'basic',
    align: ALIGN,
    width: 70
  },
  {
    title: '展示',
    key: 'pv',
    sortable: 'custom',
    type: 'basic',
    align: ALIGN,
    width: 70
  },
  {
    title: '点击',
    key: 'clickNum',
    sortable: 'custom',
    type: 'basic',
    align: ALIGN,
    width: 70
  },
  {
    title: '安装量',
    key: 'downNum',
    sortable: 'custom',
    type: 'basic',
    align: ALIGN,
    width: 70
  },
  {
    title: 'CTR',
    key: 'ctr',
    sortable: 'custom',
    type: 'basic',
    align: ALIGN,
    width: 60
  },
  {
    title: 'CVR',
    key: 'cvr',
    sortable: 'custom',
    type: 'basic',
    align: ALIGN,
    width: 60
  },
  {
    title: 'CPI',
    key: 'cpi',
    sortable: 'custom',
    type: 'basic',
    align: ALIGN,
    width: 60
  },
  {
    title: '付费次数',
    key: 'payNum',
    sortable: 'custom',
    type: 'basic',
    align: ALIGN,
    width: 84
  },
  {
    title: '付费金额',
    key: 'payMoney',
    sortable: 'custom',
    type: 'basic',
    align: ALIGN,
    width: 84
  },
  {
    title: '付费ROI',
    key: 'roi',
    sortable: 'custom',
    type: 'basic',
    align: ALIGN,
    width: 84
  },
  {
    title: '总播放数',
    key: 'totalPlay',
    sortable: 'custom',
    type: 'basic',
    align: ALIGN,
    width: 84
  },
  {
    title: '播放2S',
    key: 'over2sPlay',
    sortable: 'custom',
    type: 'basic',
    align: ALIGN,
    width: 84
  },
  {
    title: '播放3S',
    key: 'over3sPlay',
    sortable: 'custom',
    type: 'basic',
    align: ALIGN,
    width: 84
  },
  {
    title: '播放25%',
    key: 'over25Play',
    sortable: 'custom',
    type: 'basic',
    align: ALIGN,
    width: 84
  },
  {
    title: '播放50%',
    key: 'over50Play',
    sortable: 'custom',
    type: 'basic',
    align: ALIGN,
    width: 84
  },
  {
    title: '播放100%',
    key: 'over100Play',
    sortable: 'custom',
    type: 'basic',
    align: ALIGN,
    width: 88
  }
]
